<template>
  <div class="subtopic-footer">
    <div class="footer-container">
      <div class="prev">
        <img src="@/assets/img/btn-prev.png" alt="" v-show="subtopicIndex > 0" @click="onClickPrev"></img>
      </div>
      <div class="options">
        <div class="options-item" :class="{active: answer === item.value}" v-for="(item, index) in options" :key="item.value" @click="answerChange(item.value)">{{ item.name }}</div>
      </div>
      <div class="next">
        <img src="@/assets/img/btn-next.png" alt="" @click="onClickNext"></img>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "SubtopicFooter",
  props: {
    value: {
      type: [Number, String],
      default: ""
    },
    subtopicIndex: {
      type: Number,
      default: 0
    },
  },
  data() {
    return {
      options: [
        { name: "正确", value: 1 },
        { name: "错误", value: 0 }
      ],
      answer: ""
    };
  },
  watch: {
    value: {
      handler(val) {
        this.answer = val;
      },
      immediate: true
    }
  },
  methods: {
    answerChange(answer) {
      this.$emit('input', answer);
    },
    onClickPrev() {
      this.$emit('prev');
    },
    onClickNext() {
      this.$emit('next');
    }
  },
  mounted() {

  }
}
</script>

<style lang="less" scoped>
.footer-container {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.08rem;
  background: linear-gradient(165deg, #ff8927 0%, #ff6238 100%);
  box-shadow: 0px 0px 0.14rem 1px rgba(229, 92, 0, 0.55);
  border-radius: 0.42rem;
  border: 0.02rem solid #ffffff;

  .prev,
  .next {
    cursor: pointer;
    width: 0.3rem;
    height: 0.3rem;
    border-radius: 50%;
    font-size: 0;
    img {
      width: 100%;
      height: 100%;
    }
  }
  .options {
    display: flex;
    justify-content: center;
    align-items: center;
    .options-item {
      width: 0.96rem;
      height: 0.3rem;
      background: #ffe9cf;
      border-radius: 0.17rem;
      font-size: 0.16rem;
      color: #5a3600;
      text-align: center;
      line-height: 0.3rem;
      margin: 0 0.25rem;
      &.active {
        background: #FFE371;
      }
    }
  }
}
</style>